module.exports = __webpack_public_path__ + "img/5.c07e873b.png";